import { defineStore } from 'pinia';
import { useResumeScorerStore } from './scorer.store';
import { useBuilder } from './builder.store';

export const useBulletGenerator = defineStore('bullet-generator', {
	state: () => ({
		section: null,
		index: null,
		opened: false,
		data: null,
		title: null,
		showOnboardingFn: undefined,
		scorerStore: useResumeScorerStore(),
		builderStore: useBuilder()
	}),

	actions: {
		setData(section, index, openBulletGenerator, data) {
			this.section = section;
			this.index = index;
			this.data = data;
			this.opened = openBulletGenerator;
        
			if (this.opened) {
				this.scorerStore.hideResumeScorer();
				const bulletPointSection = this.builderStore.getSectionById(section);
				if (bulletPointSection.items[index]) {
					this.title = bulletPointSection.items[index].title;
				}
			}
		},
		setOpened(mode) {
			if (mode) {
				this.scorerStore.hideResumeScorer();
			}

			this.opened = mode;
		},
		reset() {
			this.section = null;
			this.index = null;
			this.opened = false;
			this.data = null;
			this.title = null;
		}
	}
});
